import { render, staticRenderFns } from "./SeatSelector.vue?vue&type=template&id=5684c125&scoped=true&"
import script from "./SeatSelector.vue?vue&type=script&lang=ts&"
export * from "./SeatSelector.vue?vue&type=script&lang=ts&"
import style0 from "./SeatSelector.vue?vue&type=style&index=0&id=5684c125&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5684c125",
  null
  
)

export default component.exports